{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "MapEmbed",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "mode",
    "height"
  ],
  "properties": {
    "mode": {
      "title": "Source",
      "enum": [
        "embedUrl",
        "query"
      ],
      "x-ui": "select"
    },
    "embedUrl": {
      "title": "Google Maps embed URL",
      "type": "string",
      "maxLength": 1500,
      "pattern": "^https://www\\.google\\.com/maps/embed\\?[^\\s<>\"']+$"
    },
    "query": {
      "title": "Address / place query",
      "type": "string",
      "maxLength": 200
    },
    "height": {
      "title": "Height (px)",
      "type": "integer",
      "minimum": 200,
      "maximum": 900
    }
  }
}
